<table aria-label="Table" class="table">
    <thead>
        <tr>
            <th *ngFor="let col of cols" scope="col">
                <div
                    (click)="col.sortable !== false && onClickOrder(col)"
                    [class.table__header--clickable]="col.sortable !== false"
                >
                    {{ col.title }}
                    <img
                        *ngIf="col.sortable !== false"
                        src="/assets/icons/arrow-sort-down.svg"
                        alt="Arrow"
                        [class.table__arrow--hidden]="!col.selected"
                        [class.table__arrow--ascendant]="col.sortDirection === 1"
                    />
                </div>
            </th>
            <th scope="col" class="table__td--last"></th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngIf="!rows">
            <tr *ngFor="let row of loadingRows">
                <td *ngFor="let col of cols">
                    <span class="loading-box"></span>
                </td>
            </tr>
        </ng-container>
        <tr *ngFor="let row of rows">
            <td *ngFor="let col of cols">
                <ng-container [ngSwitch]="col.config?.type">
                    <ng-container *ngSwitchCase="'Date'">
                        {{ row[col.name] | date: col.config.format }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'Component'">
                        <ng-container
                            *ngComponentOutlet="
                                customTemplate(col);
                                injector: customInjector(col, row)
                            "
                        />
                    </ng-container>
                    <ng-container *ngSwitchDefault>{{ row[col.name] }}</ng-container>
                </ng-container>
            </td>
            <td class="table__td--last" [class.table__td--actions]="!!actions">
                <span
                    *ngFor="let action of actions"
                    class="table__action-icon"
                    (click)="handleColAction(action.name, row)"
                >
                    <img *ngIf="!!action.iconPath" [src]="action.iconPath" [alt]="action.name" />
                    <img
                        *ngIf="!!action.iconName"
                        [src]="getIconPath(action.iconName)"
                        [alt]="action.name"
                    />
                </span>
            </td>
        </tr>
    </tbody>
</table>
